/* tslint:disable */
/* eslint-disable */

/**
 * Reason for the upgrade status, usually explaining why the upgrade is not available
 */
export enum UpgradeStatusReason {
  NotFinnairFlight = 'NOT_FINNAIR_FLIGHT',
  TooCloseToDeparture = 'TOO_CLOSE_TO_DEPARTURE',
  InfantInBooking = 'INFANT_IN_BOOKING',
  GroupBooking = 'GROUP_BOOKING',
  SsrInBooking = 'SSR_IN_BOOKING',
  TooManyPassengers = 'TOO_MANY_PASSENGERS',
  TooFarToDeparture = 'TOO_FAR_TO_DEPARTURE',
  TooCloseToDepartureForWaitlist = 'TOO_CLOSE_TO_DEPARTURE_FOR_WAITLIST',
  SegmentInRequestedUpgradeCabin = 'SEGMENT_IN_REQUESTED_UPGRADE_CABIN',
  SegmentMissingRequestedUpgradeCabin = 'SEGMENT_MISSING_REQUESTED_UPGRADE_CABIN',
  TicketNotIssuedByFinnair = 'TICKET_NOT_ISSUED_BY_FINNAIR',
  IneligibleBookingClass = 'INELIGIBLE_BOOKING_CLASS',
  BookingInIneligibleStatus = 'BOOKING_IN_INELIGIBLE_STATUS',
  FlownSegment = 'FLOWN_SEGMENT'
}
